import { createFileRoute } from "@tanstack/react-router";
import TermsOfUse from "@/pages/legal/TermsOfUse";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const breadcrumbSchema = buildBreadcrumb([{ name: "Condiciones de uso", path: "/legal/condiciones-uso" }]);

export const Route = createFileRoute("/legal/condiciones-uso")({
  head: () => ({
    meta: [
      { title: "Condiciones Generales de Uso | SEOEVOLUTION" },
      { name: "description", content: "Condiciones generales de uso de SEOEVOLUTION" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/legal/condiciones-uso" },
      { property: "og:title", content: "Condiciones Generales de Uso | SEOEVOLUTION" },
      { property: "og:description", content: "Condiciones generales de uso de SEOEVOLUTION" },
      { name: "twitter:title", content: "Condiciones Generales de Uso | SEOEVOLUTION" },
      { name: "twitter:description", content: "Condiciones generales de uso de SEOEVOLUTION" },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/legal/condiciones-uso" }],
    scripts: [ldJson(breadcrumbSchema)],
  }),
  component: TermsOfUse,
});
